export default "<div id=\"page\" data-bind=\"component: { name: route().view, params: { route: route, dataProvider: dataProvider } }\"></div>";